import Phaser from 'phaser';
import { initCatalogs } from '../turn/scenarioCatalog';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Boot' });
  }

  create(): void {
    void initCatalogs('/scenarios/').finally(() => {
      this.scene.start('MainMenu');
    });
  }
}
